/* --SML & ML
	 * REMINDER - this is used on main, outlet, admin, and artsheets
        * Example of usage:
        * var deleteCartItemDialog = new dialog4i();
        * var dialogID = document.getElementById('cartDialog');
        * var dialogTriggerBtns = document.getElementsByClassName('dialogtriggerbtn');
        * deleteCartItemDialog.init(dialogID, dialogTriggerBtns, document.getElementById('btnConfirm'));
        * ONLY use param 3 IF there is no close icon on your dialog (very few use cases for this but outlet steal a deal loading dialog is one)
*/
var dialog4i = function () { 
	let dialog,
	      triggerElement,
	      origFocus,
	      focusOnOpen,

	init = function (dlg, opensDlg, focusEl) {
		dialog = dlg;
            	
		//if (typeof opensDlg !== 'undefined' && opensDlg.length > 0) {
		if (typeof opensDlg !== 'undefined') {
			triggerElement = opensDlg;
			// if multiple trigger elements
			if (opensDlg.length > 0) {			
				for (let i = 0; i < opensDlg.length; i++) {					
					triggerElement[i].addEventListener("click", open);
					origFocus = triggerElement[i];
				}
			}else { 
				triggerElement.addEventListener("click", open);
				origFocus = triggerElement;
			}
		}else { opensDlg = null; }
            	
            	// assign focus when opened
		if (typeof focusEl !== 'undefined') focusOnOpen = focusEl;
		else if(dialog.querySelectorAll('.close4iDialog')[0]) focusOnOpen = dialog.querySelectorAll('.close4iDialog')[0]; 
		else focusOnOpen = null; 
	},
	bindCloseElements = function () {
		let closeElements = dialog.querySelectorAll('.close4iDialog');
		for (let i = 0; i < closeElements.length; i++) {
			closeElements[i].addEventListener("click", close);
		}
	},
	unbindCloseElements = function () {
		let closeElements = dialog.querySelectorAll('.close4iDialog');
		for (let i = 0; i < closeElements.length; i++) {
			closeElements[i].removeEventListener("click", close);
		}
	},
	updateFocusable = function(modal){
		// can use this to refresh the list of focusable elements inside dialog when content is changing
		let links = [].slice.call(modal.querySelectorAll('a, button:not([disabled]), [href], .close4iDialog, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
		let focusableEls = [];
		
		links.forEach(function(el){ // filter out all that have tabindex -1 added to them
			if(el.hasAttribute("tabindex") && el.getAttribute("tabindex") == "-1") return;
			else focusableEls.push(el);
		});
		let firstFocusableEl = focusableEls[0];
		let lastFocusableEl = focusableEls[focusableEls.length - 1];
		
		let trapFocus = (e) => {
			let tab = (e.which || e.keyCode) === 9;

			if (e.key === 'Tab' || tab) {
				if (e.shiftKey) /* shift + tab */ {
					if (document.activeElement === firstFocusableEl) {
						e.preventDefault();
						e.stopPropagation();
						lastFocusableEl.focus();
					}
				} else /* tab */ {
					if (document.activeElement === lastFocusableEl) {
						e.preventDefault();
						e.stopPropagation();
						firstFocusableEl.focus();
					}
				}
			}
			return;
		};
		
		// trapping focus
		modal.removeEventListener('keydown', trapFocus);
		modal.addEventListener('keydown', trapFocus);
		
		bindCloseElements();
	},
	closeOnEsc = function(e){
		if(e.which == 27) close();
	},
	open = function(e) {
		if(e){ 
			e.preventDefault();  
			origFocus = e.currentTarget;
		}
		if (origFocus) origFocus.setAttribute("aria-expanded", "true");
		
		updateFocusable(dialog);
		dialog.classList.add('showDialog');
		
		//update lazyload images if necessary
		if(typeof nativeLazyload4i !== 'undefined') nativeLazyload4i.LoadImages(); 
		else if(typeof lazyload4i !== 'undefined') lazyload4i.LoadImages(); 
		
		if(focusOnOpen !== null) focusOnOpen.focus(); 
		document.addEventListener("keyup", closeOnEsc);
	},
	close = function(e) {	
		if(e) e.preventDefault();
		
		dialog.classList.remove('showDialog');
		if (typeof origFocus !== 'undefined') {
			origFocus.setAttribute("aria-expanded", "false");
			origFocus.focus(); 
		}
		unbindCloseElements();
		document.removeEventListener("keyup", closeOnEsc);
	};
	return {
		// open and close are only really exposed in case they need to be called programatically somewhere. 
		// Just calling init handles everything internally for most scenarios.
		init: init, 
		open: open,
		close: close,
		UpdateFocusable: updateFocusable
	};
};